module.exports = __webpack_public_path__ + "static/media/hong-kong-wheel.65a7f338.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/HomePageResources/hong-kong-wheel.svg
// module id = 130
// module chunks = 0